import Vue from 'vue'
import Vuetify,{ VLayout } from 'vuetify/lib'

import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'fa',
  components: {
    VLayout
  },
  theme: {
    primary: '#000000',
    secondary: '#FFFFFF'
  }
})
